import styled from "styled-components";

export const Container = styled.form`
  text-align: center;
  width: 300px;
  .search {
    font-size: 18px;
    margin: 20px 0 10px 0;
    width: 300px;
    border: none;
    border-bottom: 1px solid var(--secondary-color);
  }
  .selectGuests {
    text-align: center;
    label {
      color: var(--secondary-color);
      display: block;
    }
    select {
      font-size: 18px;
      width: 300px;
      border: none;
      border-bottom: 1px solid var(--secondary-color);
      background-color: transparent;
    }
    margin: 20px 0 10px 0;
  }
`;
